import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3a39ad32&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3a39ad32&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=3a39ad32&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39ad32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/180f2a3c-943f-4c29-bc88-c8fc32933762/workspace/b2b2c_pc_2b_nbgr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a39ad32')) {
      api.createRecord('3a39ad32', component.options)
    } else {
      api.reload('3a39ad32', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3a39ad32&scoped=true&", function () {
      api.rerender('3a39ad32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/index.vue"
export default component.exports